import { render } from "./DashboardDropdown.vue?vue&type=template&id=46fb09d4"
import script from "./DashboardDropdown.vue?vue&type=script&lang=js"
export * from "./DashboardDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__